(() => {
  if (customElements.get('us-collection-stock-order')) return;
  const availableOnly = url => {
    url.searchParams.set('filter.v.availability', '1');
    return url;
  };
  document.addEventListener('facet:update', event => {
    if (event.detail?.url) availableOnly(event.detail.url);
  }, true);
  class AvailableCollection extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.showAvailable();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    async showAvailable() {
      const url = new URL(window.location.href);
      const required = availableOnly(new URL(url));
      if (required.search === url.search) return;
      const section = this.closest('.shopify-section');
      if (!section) return;
      availableOnly(url);
      url.searchParams.delete('page');
      const visibleUrl = new URL(url);
      url.searchParams.set('section_id', this.dataset.sectionId);
      section.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = doc.getElementById(section.id);
        if (!replacement || !this.isConnected) return;
        history.replaceState({}, '', visibleUrl.toString());
        section.replaceChildren(...document.importNode(replacement, true).childNodes);
      } catch (error) {
        if (error.name !== 'AbortError') {
          section.querySelectorAll('product-card[data-us-available="false"]').forEach(card => card.remove());
        }
      } finally {
        section.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('us-collection-stock-order', AvailableCollection);
})();
